export default {
  id: "page0",
  header: "Zgoda na przetwarzanie danych osobowych",
  questions: [
      {
      type: "justlabel",
      labelStrong: false,
      label:
        "<p>Wypełniając ankietę wyraża Pan/Pani zgodę na przetwarzanie danych osobowych w niej zawartych w celu wzięcia udziału w badaniach sensorycznych organizowanych przez Dr. Oetker Polska Sp. z o.o. z siedzibą w Gdańsku.</p>" +
        "<p>Informujemy o możliwości wycofania w dowolnym momencie udzielonej zgody przez wysłanie wiadomości e-mail na adres: ochronadanychosobowych@oetker.pl lub pisemnie na adres siedziby spółki. Cofniecie zgody nie wpływa na zgodność przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.</p>" +
        "<p>W związku z tym, że ankieta zawiera dane dot. stanu zdrowia prosimy o wyrażenie zgody na przetwarzanie tych danych.</p>" 
    },
    {
      type: "justlabel",
      label:
        "Wyrażam zgodę na przetwarzanie przez Dr. Oetker Polska Sp. z o.o. z siedzibą w Gdańsku, przy ul. Adm. Dickmana 14/15, 80-339 Gdańsk moich danych osobowych o stanie zdrowia podanych przeze mnie w formularzu, w celu wzięcia udziału w badaniach sensorycznych organizowanych przez Dr. Oetker Polska Sp. z o.o. z siedzibą w Gdańsku."
    },
    {
      label: "Wyrażam zgodę",
      type: "checkbox",
      id: "ankieta_zgodaPrzetwarzanie",
      required: true,
      columns: true,
      labelRight: true,
      labelWidth: "is-four-fifths"
    },
    
    {
      type: "justlabel",
      labelStrong: false,
      label:
        "Administratorem danych osobowych jest Dr. Oetker Polska Sp. z o.o. z siedzibą  w Gdańsku przy ul. Adm. Dickmana 14/15, 80-339 Gdańsk. Dane osobowe będą przetwarzane w celu właściwej organizacji badań sensorycznych. Uczestnik ma prawo żądania dostępu do danych osobowych, ich sprostowania, usunięcia lub ograniczenia, a także prawo do wniesienia sprzeciwu wobec przetwarzania oraz do przeniesienia danych; cofnięcia zgody na przetwarzanie danych w celu uczestnictwa w badaniach organizowanych przez Pracownię Analizy Sensorycznej w dowolnym momencie poprzez wysłanie wiadomości na adres ochronadanychosobowych@oetker.pl; cofnięcie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem; wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych dotyczącej przetwarzania przez nas Państwa danych osobowych. Więcej informacji dot. przetwarzania danych znajduję się <a target='_new_window' href='https://www.oetker.pl/pl-pl/dodatkowe-informacje/udzial-w-badaniach-organizowanych-przez-pracownie-analizy-sensorycznej.html'>tutaj</a>"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page0.js